import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { createSearchParams, useNavigate } from "react-router-dom";

// Components
import ProviderFilterSelect from "components/molecules/ProviderFilterSelect";

// Constants
import { GET_PARAMS, GET_POPUP_TYPES } from "constants/popupConfig";

// Hooks
import { useGTM } from "hooks/useGTM";
import useQueryParam from "hooks/useQueryParam";

// Selectors
import * as gamesSelector from "redux/game/selectors";

const ProviderFilterSelectContainer = () => {
  const GTM = useGTM();
  const providersQuery = useQueryParam(GET_PARAMS.PROVIDERS);
  const filter = useSelector(gamesSelector.filter);
  const navigate = useNavigate();
  const methods = useForm();

  useEffect(() => {
    if (!providersQuery) {
      methods.reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [providersQuery]);

  const handleFilterSelectClick = () => {
    navigate({
      search: `?${createSearchParams({ [GET_PARAMS.POPUP]: GET_POPUP_TYPES.popup.provider })}`,
    });
    GTM.openProvidersFilter();
  };

  return (
    <ProviderFilterSelect
      providers={filter.providers}
      onClick={handleFilterSelectClick}
    />
  );
};

export default ProviderFilterSelectContainer;
